// Refuses every request to the demo's placeholder API host. The demo has no
// session, so the cloud paths should stay idle anyway; this makes sure a path
// that forgets fails quietly instead of reaching the network.
import { DEMO_API_HOST } from './demoMode'

function isDemoApiUrl(input: string | URL): boolean {
  try {
    return new URL(String(input), window.location.href).hostname === DEMO_API_HOST
  } catch {
    return false
  }
}

const nativeFetch = window.fetch.bind(window)
window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const url = input instanceof Request ? input.url : input
  if (isDemoApiUrl(url)) {
    return Promise.reject(new TypeError('Cloud features are not available in the demo'))
  }
  return nativeFetch(input, init)
}

const NativeWebSocket = window.WebSocket
window.WebSocket = class extends NativeWebSocket {
  constructor(url: string | URL, protocols?: string | string[]) {
    if (isDemoApiUrl(url)) throw new Error('Cloud features are not available in the demo')
    super(url, protocols)
  }
}
